(() => {
  'use strict';
  const state = window.DecolabMeasurement || {};
  const wantsInternal = new URLSearchParams(location.search).get('dc_internal') === '1';
  const preview = state.designMode || window.Shopify?.designMode || window.Shopify?.previewMode;
  let privacy;
  let clarityStarted = false;
  let panel;

  function message(text) {
    const status = panel?.querySelector('[role="status"]');
    if (status) status.textContent = text;
  }

  function denyInternal(done) {
    if (!privacy) return;
    privacy.setTrackingConsent({ analytics: false, marketing: false, sale_of_data: false }, (result) => {
      if (result?.error) {
        message('Não foi possível salvar a preferência. Tente novamente.');
        return;
      }
      done?.();
    });
  }

  function syncClarity() {
    if (!privacy || state.internal || state.staff || preview) return;
    const allowed = privacy.analyticsProcessingAllowed();
    if (!allowed && !clarityStarted) return;
    window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
    window.clarity('consentv2', {
      analytics_Storage: allowed ? 'granted' : 'denied',
      ad_Storage: privacy.marketingAllowed() ? 'granted' : 'denied'
    });
    if (clarityStarted) return;
    // One installation only: the Shopify Clarity app embed remains disabled.
    if (!document.querySelector('script[src*="clarity.ms/tag/"]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.clarity.ms/tag/yitmfcb4f2';
      document.head.appendChild(script);
    }
    clarityStarted = true;
  }

  if (wantsInternal || (state.staff && !state.internal)) {
    panel = document.createElement('aside');
    panel.className = 'dc-internal-settings';
    panel.setAttribute('aria-label', 'Preferências de medição deste navegador');
    const title = document.createElement('strong');
    title.textContent = 'Acesso interno Decolab';
    const status = document.createElement('p');
    status.setAttribute('role', 'status');
    status.textContent = state.internal ? 'Este navegador está excluído da medição opcional.' : 'Exclua suas visitas administrativas neste navegador. A preferência não altera a navegação dos clientes.';
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = 'Excluir este navegador das métricas';
    button.disabled = true;
    button.addEventListener('click', () => {
      button.disabled = true;
      denyInternal(() => {
        try { localStorage.setItem('dc_internal_traffic', '1'); } catch (error) { /* Native consent still persists. */ }
        state.internal = true;
        location.reload();
      });
    });
    panel.append(title, status);
    if (!state.internal) panel.append(button);
    document.body.prepend(panel);
  }

  function ready() {
    privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;
    if (panel) {
      const button = panel.querySelector('button');
      if (button) button.disabled = false;
    }
    if (state.internal || state.staff) {
      denyInternal(() => {
        if (!state.staff) return;
        try { localStorage.setItem('dc_internal_traffic', '1'); } catch (error) { /* Native consent still persists. */ }
        state.internal = true;
        message('Este navegador está excluído da medição opcional.');
        panel?.querySelector('button')?.remove();
      });
    }
    syncClarity();
  }
  document.addEventListener('visitorConsentCollected', syncClarity);
  if (window.Shopify?.customerPrivacy) ready();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) { message('A preferência ainda não pôde ser carregada. Atualize a página para tentar novamente.'); return; }
      ready();
    });
  }
})();
